var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { device } from "@/Theme";
export var OffCanvasBodyWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 20px 30px 100px;\n\n    ", " {\n        padding: 20px 40px 100px;\n    }\n"], ["\n    padding: 20px 30px 100px;\n\n    ", " {\n        padding: 20px 40px 100px;\n    }\n"])), device.small);
var templateObject_1;
